import React, { useEffect } from 'react';

import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Button } from '@BICE_Vida/components';
import styles from './Sidebar.module.scss';
import { headerSections } from '@/utils/generalTexts';
import routes from '@/utils/routes';

const Sidebar = ({ show }: { show: boolean }) => {
  const router = useRouter();
  const currentRoute = router.pathname;

  const sidebarClass = classNames(styles.sidebar, {
    [styles.show]: show,
  });

  const itemClass = (active: boolean) =>
    classNames(styles.sidebar_link, {
      [styles.active]: active,
    });

  return (
    <div className={sidebarClass}>
      {headerSections.map((item, index) => (
        <div className={styles.sidebar_item} key={item.id + index}>
          <Link className={itemClass(currentRoute === item.link)} href={item.link}>
            <span>{item.label}</span>
          </Link>
        </div>
      ))}
      <Button
        className={styles.sidebar_btn_recover}
        id="navbar_header_btn_recover_hiring"
        text="Retomar contratación"
        size="medium"
        variant="outline"
        onClick={() => router.push(routes.recoverHiring)}
      />
    </div>
  );
};

export default Sidebar;
